import { render, staticRenderFns } from "./ThePersonalIcon.vue?vue&type=template&id=849ddfe8&"
import script from "./ThePersonalIcon.vue?vue&type=script&lang=js&"
export * from "./ThePersonalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports